const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  accommodationSearch: (communeId: string, query: string) => `${apiUrl}/v2/accommodation/search/${communeId}/${query}`,
  accommodationFetch: (communeId: string, uid: string) => `${apiUrl}/v2/accommodation/fetch/${communeId}/${uid}`,
};
